// @ts-nocheck

import React from 'react';

import { CloseIcon, StyledExitButton } from './ExitButton.style';

type ExitButtonProps = {
  onClick: (...params: unknown) => unknown;
  className?: string;
  zIndex?: number;
  isCloseButtonInside?: boolean;
};

export const ExitButton = ({ className, zIndex, onClick, isCloseButtonInside = false }: ExitButtonProps) => (
  <StyledExitButton className={className} onClick={onClick} $zIndex={zIndex} $positionInside={isCloseButtonInside}>
    <CloseIcon />
  </StyledExitButton>
);

export default ExitButton;
